/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu, Jul 22nd 2021, 8:18:02 am
 *
 * *****************************************************
 */

import { TextStyle } from '@shopify/polaris';

import Spinner from 'features/common/views/components/Spinner';

import { Container } from './styles';

/**
 * Loading content when creating workspace
 */
const CreateWorkspaceLoading = () => {
  return (
    <Container>
      <div>
        <Spinner />
        <TextStyle variation="subdued">Setting up your new workspace...</TextStyle>
      </div>
    </Container>
  );
};

export default CreateWorkspaceLoading;
